import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["star", "input"]
  static values = { rating: { type: Number, default: 0 } }

  connect() {
    this.render()
  }

  rate({ params: { score } }) {
    this.ratingValue = score
    this.inputTarget.value = score
    this.render()
  }

  render() {
    this.starTargets.forEach((star, index) => {
      if (index < this.ratingValue) {
        star.classList.add("text-amber")
        star.classList.remove("text-border")
      } else {
        star.classList.remove("text-amber")
        star.classList.add("text-border")
      }
    })
  }
}
